(function () {
  'use strict';

  document.documentElement.classList.add('js');

  const ENABLE_HERO_PATTERN_BG = false;
  const USE_DROP_ANIMATION = true;

  const FLAVORS = [
    { name: 'Green Apple', tag: 'GREEN APPLE', pill: 'Ultra focus' },
    { name: 'Tangerine', tag: 'TANGERINE', pill: 'Zesty & bright' },
  ];

  const T = window.GULP_THEME || null;
  const MOUTH_ICON = T
    ? [T.iconGreen, T.iconOrange]
    : ['assets/icon-green.svg', 'assets/icon-orange.svg'];
  const MOUTH_TINT_CLASSES = ['mouth-tint-green', 'mouth-tint-orange'];
  const FLAVOR_COLORS = ['#1FB257', '#FF8A2A'];

  let currentFlavor = 0;
  let touchStartX = 0;
  let touchEndX = 0;

  const $ = function (id) {
    return document.getElementById(id);
  };

  const loader = $('loader');
  const hero = $('hero');
  const flavorStrip = $('flavorStrip');
  const carouselPrev = $('carouselPrev');
  const carouselNext = $('carouselNext');
  const pillDynamic = $('pillDynamic');
  const navToggle = $('navToggle');
  const navClose = $('navClose');
  const navBackdrop = $('navBackdrop');
  const nav = $('nav');
  const mouthBase = $('mouthBase');
  const mouthTablet = $('mouthTablet');
  const mouthPeekPrev = $('mouthPeekPrev');
  const mouthPeekNext = $('mouthPeekNext');
  const mouthRipple = $('mouthRipple');
  const promoBar = $('promoBar');
  const promoBarClose = $('promoBarClose');
  const stickyBar = $('stickyBar');
  const mobileCta = $('mobileStickyCta');
  const mobileCtaButton = mobileCta ? mobileCta.querySelector('.mobile-sticky-cta-btn') : null;
  const mobileCtaShopHref = mobileCtaButton ? mobileCtaButton.getAttribute('href') : '#flavors';
  const themeToggle = $('themeToggle');
  const footerYear = $('footerYear');

  if (footerYear) footerYear.textContent = String(new Date().getFullYear());

  function setMobileCtaCartState(itemCount) {
    if (!mobileCtaButton) return;
    const hasItems = itemCount > 0;
    mobileCtaButton.textContent = hasItems ? 'Go to Basket' : 'Shop GULP';
    mobileCtaButton.setAttribute('href', hasItems ? '/cart' : mobileCtaShopHref);
  }

  function bumpBasketCounts(n) {
    var nextCount = typeof n === 'number' ? n : null;
    document.querySelectorAll('.basket-count, .gulp-pdp-cart-count').forEach(function (el) {
      var count = nextCount === null ? parseInt(el.textContent || '0', 10) + 1 : nextCount;
      el.textContent = String(count);
      el.classList.add('has-items');
      if (nextCount === null) nextCount = count;
    });
    setMobileCtaCartState(nextCount === null ? 1 : nextCount);
  }

  function setBasketCountsFromCart(cart) {
    const n = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('.basket-count, .gulp-pdp-cart-count').forEach(function (el) {
      el.textContent = String(n);
      el.classList.toggle('has-items', n > 0);
    });
    setMobileCtaCartState(n);
  }

  function refreshCartBadge() {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setBasketCountsFromCart(cart);
      })
      .catch(function () {});
  }

  if (ENABLE_HERO_PATTERN_BG && T && T.fullLogoBg) {
    const container = $('heroPatternBg');
    if (container) {
      const count = 36;
      for (let i = 0; i < count; i++) {
        const img = document.createElement('img');
        img.src = T.fullLogoBg;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        Object.assign(img.style, {
          position: 'absolute',
          pointerEvents: 'none',
          left: Math.random() * 110 - 5 + '%',
          top: Math.random() * 110 - 5 + '%',
          width: 80 + Math.random() * 200 + 'px',
          opacity: String(0.015 + Math.random() * 0.03),
          transform: 'rotate(' + (Math.random() * 50 - 25) + 'deg)',
        });
        container.appendChild(img);
      }
    }
  }

  function hideLoader() {
    if (!loader) return;
    loader.classList.add('hidden');
    setTimeout(function () {
      loader.style.display = 'none';
    }, 800);
  }
  if (loader) setTimeout(hideLoader, 1600);

  (function initTheme() {
    const KEY = 'gulp-theme';
    const root = document.documentElement;

    function getStoredTheme() {
      try {
        return localStorage.getItem(KEY);
      } catch (e) {
        return null;
      }
    }

    function setTheme(value) {
      const theme = value === 'dark' ? 'dark' : 'light';
      root.setAttribute('data-theme', theme);
      try {
        localStorage.setItem(KEY, theme);
      } catch (e) {}
    }

    const stored = getStoredTheme();
    setTheme(stored === 'dark' ? 'dark' : 'light');

    if (themeToggle) {
      themeToggle.addEventListener('click', function () {
        setTheme(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark');
      });
    }
  })();

  function setHeaderHeight() {
    var header = document.querySelector('.header');
    var promo = document.getElementById('promoBar');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
    if (
      promo &&
      document.body.classList.contains('promo-visible') &&
      !promo.classList.contains('hidden')
    ) {
      document.documentElement.style.setProperty('--promo-bar-height', promo.offsetHeight + 'px');
    } else {
      document.documentElement.style.setProperty('--promo-bar-height', '0px');
    }
  }

  if (promoBar && promoBarClose) {
    document.body.classList.add('promo-visible');
    promoBarClose.addEventListener('click', function () {
      promoBar.classList.add('hidden');
      document.body.classList.remove('promo-visible');
      setHeaderHeight();
    });
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);

  (function initStickyBar() {
    if (!stickyBar) return;
    var threshold = 380;
    var maxMobile = 768;

    function isMobile() {
      return window.innerWidth <= maxMobile;
    }

    function update() {
      if (isMobile()) {
        stickyBar.classList.remove('visible');
        return;
      }
      stickyBar.classList.toggle('visible', window.scrollY > threshold);
    }

    window.addEventListener(
      'scroll',
      function () {
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      requestAnimationFrame(update);
    });
    update();
  })();

  (function initMobileCta() {
    if (!mobileCta) return;
    const threshold = 320;

    function update() {
      if (window.innerWidth > 768) {
        mobileCta.classList.remove('visible');
        mobileCta.setAttribute('aria-hidden', 'true');
        return;
      }
      const visible = window.scrollY > threshold;
      mobileCta.classList.toggle('visible', visible);
      mobileCta.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    window.addEventListener(
      'scroll',
      function () {
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
    update();
  })();

  (function initReveal() {
    const reveal = document.querySelectorAll('.reveal-on-scroll');
    if (!reveal.length || !('IntersectionObserver' in window)) {
      reveal.forEach(function (el) {
        el.classList.add('reveal');
      });
      return;
    }
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('reveal');
        });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0.1 }
    );
    reveal.forEach(function (el) {
      observer.observe(el);
    });
  })();

  (function initReviewsCarousel() {
    document.querySelectorAll('.reviews-carousel').forEach(function (carousel) {
      const track = carousel.querySelector('[data-reviews-track]');
      const prev = carousel.querySelector('[data-reviews-prev]');
      const next = carousel.querySelector('[data-reviews-next]');
      if (!track || !prev || !next) return;

      function step() {
        const card = track.querySelector('.review-card');
        if (!card) return track.clientWidth;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  })();

  (function initReelsVideo() {
    const videos = document.querySelectorAll('.reel-video');
    if (!videos.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      videos.forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) {
        v.play().catch(function () {});
      });
      return;
    }
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const v = entry.target;
          if (!(v instanceof HTMLVideoElement)) return;
          if (entry.isIntersecting) v.play().catch(function () {});
          else v.pause();
        });
      },
      { rootMargin: '60px 0px', threshold: 0.35 }
    );
    videos.forEach(function (v) {
      observer.observe(v);
    });
  })();

  function addLineItem(variantId, quantity) {
    if (!variantId) return Promise.reject(new Error('Product unavailable'));
    var qty = Math.max(1, parseInt(quantity || '1', 10) || 1);
    var numericVariantId = Number(variantId);
    const payload = {
      id: numericVariantId,
      quantity: qty,
    };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) {
          return r
            .json()
            .catch(function () {
              return {};
            })
            .then(function (j) {
              throw j && j.description ? new Error(String(j.description)) : new Error('Add to cart failed');
            });
        }
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var matchingLine = cart.items && cart.items.find(function (item) {
          return Number(item.variant_id) === numericVariantId;
        });
        if (!matchingLine) {
          throw new Error('Cart did not update');
        }
        setBasketCountsFromCart(cart);
        return cart;
      });
  }

  function setFlavor(index) {
    index = ((index % FLAVORS.length) + FLAVORS.length) % FLAVORS.length;
    currentFlavor = index;
    if (hero) hero.setAttribute('data-flavor', String(index));

    const flavor = FLAVORS[index];
    if (!flavor) return;

    if (pillDynamic) pillDynamic.textContent = flavor.pill;

    if (mouthBase) {
      mouthBase.classList.remove('mouth-tint-green', 'mouth-tint-orange');
      mouthBase.classList.add(MOUTH_TINT_CLASSES[index] || 'mouth-tint-green');
    }

    if (mouthTablet && USE_DROP_ANIMATION) {
      mouthTablet.classList.remove('tablet-drop-in', 'tablet-visible');
      if (mouthRipple) {
        mouthRipple.classList.remove('ring');
        mouthRipple.offsetHeight;
        mouthRipple.classList.add('ring');
        setTimeout(function () {
          mouthRipple.classList.remove('ring');
        }, 800);
      }
      mouthTablet.offsetHeight;
      mouthTablet.classList.add('tablet-drop-in');
      setTimeout(function () {
        mouthTablet.classList.remove('tablet-drop-in');
        mouthTablet.classList.add('tablet-visible');
      }, 850);
    }

    if (mouthPeekPrev) mouthPeekPrev.src = MOUTH_ICON[((index - 1) + FLAVORS.length) % FLAVORS.length];
    if (mouthPeekNext) mouthPeekNext.src = MOUTH_ICON[(index + 1) % FLAVORS.length];

    document.querySelectorAll('.flavor-tag').forEach(function (tag) {
      tag.classList.toggle('active', Number(tag.getAttribute('data-flavor')) === index);
    });
  }

  function prev() {
    setFlavor(currentFlavor - 1);
  }

  function next() {
    setFlavor(currentFlavor + 1);
  }

  const heroHasCarousel = Boolean(flavorStrip || mouthBase);
  if (flavorStrip) {
    flavorStrip.querySelectorAll('.flavor-tag').forEach(function (tag) {
      tag.addEventListener('click', function () {
        setFlavor(Number(tag.getAttribute('data-flavor')));
      });
    });
  }
  if (carouselPrev) carouselPrev.addEventListener('click', prev);
  if (carouselNext) carouselNext.addEventListener('click', next);

  if (hero && heroHasCarousel) {
    hero.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      },
      { passive: true }
    );
    hero.addEventListener(
      'touchend',
      function (e) {
        touchEndX = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
        const diff = touchStartX - touchEndX;
        if (diff > 60) next();
        else if (diff < -60) prev();
      },
      { passive: true }
    );
  }

  if (heroHasCarousel) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });
    setFlavor(0);
  }

  (function initInstafeedMount() {
    const mount = document.querySelector('[data-instafeed-mount]');
    if (!mount) return;

    const main = document.querySelector('.main');
    if (!main) return;

    function isInvalidFeedRoot(el) {
      return (
        !el ||
        el === mount ||
        mount.contains(el) ||
        el.classList.contains('section-gulp-storefront') ||
        el.closest('.section-gulp-storefront')
      );
    }

    function looksLikeInstafeed(el) {
      if (isInvalidFeedRoot(el)) {
        return false;
      }
      const signature = (el.id + ' ' + el.className + ' ' + el.textContent).toLowerCase();
      return (
        signature.indexOf('instafeed') !== -1 ||
        signature.indexOf('instagram feed') !== -1 ||
        !!el.querySelector('img[alt^="Instagram post"], [aria-label*="Instagram post"]')
      );
    }

    function findFeedSection() {
      const post = document.querySelector(
        'img[alt^="Instagram post"]:not(.social-tile-media), [aria-label*="Instagram post"]:not(.social-tile)'
      );
      if (post) {
        const root =
          post.closest('.shopify-section') ||
          post.closest('[id*="instafeed" i]') ||
          post.closest('[class*="instafeed" i]') ||
          post.closest('section') ||
          post.parentElement;
        if (!isInvalidFeedRoot(root)) return root;
      }

      const sections = Array.prototype.slice.call(main.children);
      return sections.find(looksLikeInstafeed);
    }

    function moveFeed() {
      const feedSection = findFeedSection();
      if (!feedSection) return false;

      const fallback = mount.querySelector('[data-social-fallback]');
      if (fallback) {
        fallback.hidden = true;
        fallback.style.display = 'none';
      }
      mount.classList.add('has-instafeed');
      feedSection.classList.add('social-instafeed-section');
      mount.appendChild(feedSection);
      return true;
    }

    if (moveFeed()) return;

    const observer = new MutationObserver(function () {
      if (moveFeed()) observer.disconnect();
    });
    observer.observe(main, { childList: true, subtree: true });

    var attempts = 0;
    const interval = setInterval(function () {
      attempts += 1;
      if (moveFeed() || attempts >= 20) {
        clearInterval(interval);
        observer.disconnect();
      }
    }, 500);
  })();

  function formatPrice(amount) {
    return '£' + Number(amount).toFixed(2);
  }

  function initTubePackToggle(root) {
    if (!root || !root.hasAttribute('data-variant-tube')) return;

    const hasPack2 =
      root.getAttribute('data-has-pack2') === 'true' ||
      !!root.querySelector('.flavor-card-option[data-option="pack2"], .flavor-card-option[data-option="pack"]');
    const hasPack4 =
      root.getAttribute('data-has-pack4') === 'true' ||
      !!root.querySelector('.flavor-card-option[data-option="pack4"]');
    const hasPack6 =
      root.getAttribute('data-has-pack6') === 'true' ||
      !!root.querySelector('.flavor-card-option[data-option="pack6"]');
    const priceDisplay = root.querySelector('[data-price-display]');
    const priceWas = root.querySelector('[data-price-was]');
    const priceUnit = root.querySelector('[data-price-unit]');
    const cta = root.querySelector('[data-add-to-cart]');
    const paymentButtonWrapper = root.querySelector('[data-payment-button-wrapper]');
    const productFormVariantInput = root.querySelector('[data-product-form-variant-id], #gulpPdpVariantId');
    const productFormQuantityInput = root.querySelector('[data-product-form-quantity], #gulpPdpQuantity');

    const priceTube = parseFloat(root.dataset.priceTube || '0');
    const pricePack2 = parseFloat(root.dataset.pricePack2 || '0');
    const pricePack4 = parseFloat(root.dataset.pricePack4 || '0');
    const pricePack6 = parseFloat(root.dataset.pricePack6 || '0');
    const wasTube = parseFloat(root.dataset.wasTube || '0');
    const wasPack2 = parseFloat(root.dataset.wasPack2 || '0');
    const wasPack4 = parseFloat(root.dataset.wasPack4 || '0');
    const wasPack6 = parseFloat(root.dataset.wasPack6 || '0');

    function normalizeMode(mode) {
      var m = mode || 'tube';
      if (m === 'pack') m = 'pack2';
      if (m === 'pack2' && !hasPack2) m = 'tube';
      if (m === 'pack4' && !hasPack4) m = hasPack2 ? 'pack2' : 'tube';
      if (m === 'pack6' && !hasPack6) m = hasPack4 ? 'pack4' : (hasPack2 ? 'pack2' : 'tube');
      return m;
    }

    function isAvailable(mode) {
      var m = normalizeMode(mode);
      if (m === 'tube') return root.dataset.availableTube === '1';
      if (m === 'pack2') return root.dataset.availablePack2 !== '0' && !!variantIdFor(m);
      if (m === 'pack4') return root.dataset.availablePack4 !== '0' && !!variantIdFor(m);
      if (m === 'pack6') return root.dataset.availablePack6 !== '0' && !!variantIdFor(m);
      return false;
    }

    function variantIdFor(mode) {
      var m = normalizeMode(mode);
      if (m === 'pack4') return root.dataset.variantPack4 || root.dataset.variantTube;
      if (m === 'pack6') return root.dataset.variantPack6 || root.dataset.variantTube;
      if (m === 'pack2') return root.dataset.variantPack2 || root.dataset.variantTube;
      return root.dataset.variantTube;
    }

    function quantityFor(mode) {
      var m = normalizeMode(mode);
      if (m === 'pack4') return parseInt(root.dataset.quantityPack4 || '4', 10) || 4;
      if (m === 'pack6') return parseInt(root.dataset.quantityPack6 || '6', 10) || 6;
      if (m === 'pack2') return parseInt(root.dataset.quantityPack2 || '2', 10) || 2;
      return parseInt(root.dataset.quantityTube || '1', 10) || 1;
    }

    function applyMode(mode) {
      var effective = normalizeMode(mode);

      var price = priceTube;
      var was = wasTube;
      if (effective === 'pack6' && hasPack6) {
        price = pricePack6;
        was = wasPack6;
      } else if (effective === 'pack4' && hasPack4) {
        price = pricePack4;
        was = wasPack4;
      } else if (effective === 'pack2' && hasPack2) {
        price = pricePack2;
        was = wasPack2;
      }

      var variantId = variantIdFor(effective);

      root.querySelectorAll('.flavor-card-option').forEach(function (b) {
        var opt = b.dataset.option;
        if (opt === 'pack') opt = 'pack2';
        var isActive = opt === effective;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      if (priceDisplay) priceDisplay.textContent = formatPrice(price);

      if (priceWas) {
        if (was > 0 && was > price) {
          priceWas.textContent = formatPrice(was);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }

      if (priceUnit) {
        if (effective === 'pack6' && hasPack6 && pricePack6 > 0) {
          priceUnit.textContent = '6 tubes · ' + formatPrice(pricePack6 / 6) + ' / tube';
        } else if (effective === 'pack4' && hasPack4 && pricePack4 > 0) {
          priceUnit.textContent = '4 tubes · ' + formatPrice(pricePack4 / 4) + ' / tube';
        } else if (effective === 'pack2' && hasPack2 && pricePack2 > 0) {
          priceUnit.textContent = '2 tubes · ' + formatPrice(pricePack2 / 2) + ' / tube';
        } else {
          priceUnit.textContent = '1 tube · 20 effervescent tablets';
        }
      }

      if (cta && variantId) {
        cta.setAttribute('data-variant-id', String(variantId));
        cta.removeAttribute('data-go-to-cart');
        var ok = isAvailable(effective);
        cta.disabled = !ok;
        cta.textContent = ok ? 'Add to Basket' : 'Sold out';
        if (paymentButtonWrapper) paymentButtonWrapper.hidden = !ok;
      }

      if (productFormVariantInput && variantId) {
        productFormVariantInput.value = String(variantId);
      }

      if (productFormQuantityInput) {
        productFormQuantityInput.value = String(quantityFor(effective));
      }

      root.dataset.activeMode = effective;
    }

    root.querySelectorAll('.flavor-card-option[data-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyMode(btn.getAttribute('data-option') || 'tube');
      });
    });

    var start = root.dataset.activeMode || (hasPack2 ? 'pack2' : 'tube');
    if (!isAvailable(normalizeMode(start))) {
      if (hasPack2 && isAvailable('pack2')) start = 'pack2';
      else if (hasPack4 && isAvailable('pack4')) start = 'pack4';
      else if (hasPack6 && isAvailable('pack6')) start = 'pack6';
    }
    applyMode(start);
  }

  document.querySelectorAll('.flavor-card[data-variant-tube], .gulp-pdp[data-variant-tube]').forEach(function (el) {
    initTubePackToggle(el);
  });

  function selectedVariantIdForCard(card) {
    if (!card) return '';
    const mode = card.dataset.activeMode || 'tube';
    if (mode === 'pack6') return card.dataset.variantPack6 || card.dataset.variantTube;
    if (mode === 'pack4') return card.dataset.variantPack4 || card.dataset.variantTube;
    if (mode === 'pack2' || mode === 'pack') return card.dataset.variantPack2 || card.dataset.variantTube;
    return card.dataset.variantTube;
  }

  function selectedQuantityForCard(card) {
    if (!card) return 1;
    const mode = card.dataset.activeMode || 'tube';
    if (mode === 'pack6') return parseInt(card.dataset.quantityPack6 || '6', 10) || 6;
    if (mode === 'pack4') return parseInt(card.dataset.quantityPack4 || '4', 10) || 4;
    if (mode === 'pack2' || mode === 'pack') return parseInt(card.dataset.quantityPack2 || '2', 10) || 2;
    return parseInt(card.dataset.quantityTube || '1', 10) || 1;
  }

  document.addEventListener('click', function (e) {
    const cardBtn = e.target.closest('[data-add-to-cart]');
    if (!cardBtn) return;
    const card = cardBtn.closest('.flavor-card');
    if (!card || !card.hasAttribute('data-variant-tube')) return;
    e.preventDefault();
    e.stopPropagation();

    if (cardBtn.hasAttribute('data-go-to-cart')) {
      window.location.href = '/cart';
      return;
    }

    const variantId = selectedVariantIdForCard(card);
    const quantity = selectedQuantityForCard(card);
    const original = cardBtn.textContent;

    function showAdded() {
      cardBtn.textContent = 'Go to Basket';
      cardBtn.setAttribute('data-go-to-cart', 'true');
    }

    if (variantId) {
      addLineItem(variantId, quantity)
        .then(function () {
          showAdded();
        })
        .catch(function (err) {
          cardBtn.textContent = err && err.message ? err.message : 'Add failed';
          setTimeout(function () {
            cardBtn.textContent = original;
          }, 2500);
        });
    } else {
      cardBtn.textContent = 'Product unavailable';
      setTimeout(function () {
        cardBtn.textContent = original;
      }, 2500);
    }
  });

  function setNavOpen(open) {
    if (!nav) return;
    nav.classList.toggle('open', open);
    document.body.classList.toggle('nav-open', open);
    if (navBackdrop) {
      navBackdrop.classList.toggle('is-visible', open);
    }
  }

  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      setNavOpen(!nav.classList.contains('open'));
    });
  }
  if (navClose && nav) {
    navClose.addEventListener('click', function () {
      setNavOpen(false);
    });
  }
  if (navBackdrop) {
    navBackdrop.addEventListener('click', function () {
      setNavOpen(false);
    });
  }
  if (nav) {
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setNavOpen(false);
      });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav && nav.classList.contains('open')) {
      setNavOpen(false);
    }
  });

  const mouthStage = hero ? hero.querySelector('.mouth-stage') : null;
  if (hero && mouthStage && window.matchMedia('(min-width: 900px)').matches) {
    hero.addEventListener('mousemove', function (e) {
      const rect = hero.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      mouthStage.style.transform =
        'perspective(800px) rotateY(' + x * 5 + 'deg) rotateX(' + -y * 3 + 'deg)';
    });
    hero.addEventListener('mouseleave', function () {
      mouthStage.style.transform = '';
    });
  }

  refreshCartBadge();

  window.GULP = {
    setFlavor: setFlavor,
    getCurrentFlavor: function () {
      return currentFlavor;
    },
    getFlavors: function () {
      return FLAVORS.slice();
    },
    refreshCartBadge: refreshCartBadge,
  };
})();
